import {
  Button,
  Icon,
  IconButton,
  If,
  P,
  Stack,
  Stepper,
} from '@fashionnovateam/nova-ui-toolkit';

export type ASNHeaderProps = {
  poNumber: string;
  onContinue: () => void;
  onClose: () => void;
  currentStep: number;
  lastSaved: string;
};

function ASNHeader({
  poNumber,
  onContinue,
  onClose,
  currentStep,
  lastSaved,
}: ASNHeaderProps) {
  return (
    <div
      className="twp flex justify-between items-center w-full bg-neutral-100 xl:bg-neutral-0 rounded-b-xl border-b nu-border-neutral-200 xl:px-10 py-3 px-6 sticky top-0 left-0 z-10 text-nowrap"
      data-testid="asn-header"
    >
      <div className="flex items-center gap-2">
        <IconButton
          icon={<Icon name="multiple-cross/multiple-cross-cancel-default" />}
          label="Close"
          color="secondary"
          size="md"
          onClick={onClose}
        />
        <If condition={!!poNumber}>
          <P size="xl" color="primary" className="font-medium">
            {`${poNumber} ASN`}
          </P>
        </If>
      </div>
      <div className="">
        <Stepper
          activeStep={currentStep}
          steps={[
            {
              label: 'ASN Configuration',
            },
            {
              label: 'Print & Pack',
            },
          ]}
        />
      </div>
      <Stack direction="row" gap="sm" align="center" width="fit">
        <P size="xsm" color="success">
          {lastSaved ? `Last saved ${lastSaved}` : ''}
        </P>
        <Button
          color="primary"
          size="md"
          onClick={onContinue}
          data-testid="asn-continue-button"
        >
          Continue
        </Button>
      </Stack>
    </div>
  );
}

export default ASNHeader;
